module.exports = __webpack_public_path__ + "media/audio5.74f21750.mp3";